<fullscreen-page>
  <content-column look="dark" helpSwitch="true">
    <div slot="content" class="p-3 flex-fill w-100 mx-auto overflow-hidden">
      <dx-data-grid id="gridContainer"
                    class="h-100"
                    [dataSource]="dataSource"
                    [remoteOperations]="false"
                    [allowColumnReordering]="true"
                    [rowAlternationEnabled]="true"
                    [allowColumnResizing]="true"
                    [showBorders]="true"
                    [showColumnHeaders]="false"
                    mode="multiple">

        <dxo-paging [pageSize]="50"></dxo-paging>
        <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>

        <dxo-editing mode="popup"
                     [allowUpdating]="isAdmin()"
                     [allowDeleting]="isAdmin()"
                     [allowAdding]="isAdmin()">
          <dxo-data-grid-popup title="Edit article"
                               [showTitle]="true"
                               width="80%"
                               height="80%">
          </dxo-data-grid-popup>
          <dxo-form class="flex-fill w-100" [colCount]="1">
            <dxi-item itemType="group" [colCount]="3">
              <dxi-item dataField="headLine"></dxi-item>
              <dxi-item dataField="releaseDate" editorType="dxDateBox"></dxi-item>
              <dxi-item dataField="active" editorType="dxSwitch"></dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
              <dxi-item dataField="content"
                        editorType="dxHtmlEditor"
                        [colSpan]="3"
                        [editorOptions]="{ height: 420 }">
              </dxi-item>
              </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxo-master-detail [enabled]="true" template="detail"></dxo-master-detail>
        <div *dxTemplate="let article of 'detail'">
          <dx-html-editor readOnly="true" value="{{ article.data.content }}"></dx-html-editor>
        </div>
        <dxi-column  caption="new" [width]="25" [allowEditing]="false" cellTemplate="newCellTemplate"></dxi-column>

        <div *dxTemplate="let d of 'newCellTemplate'">
          <span *ngIf="needsBadge(d)" class="badge">0</span>
        </div>

        <dxi-column dataField="headLine"></dxi-column>
        <dxi-column dataField="content" [visible]="false"></dxi-column>
        <dxi-column dataField="releaseDate" dataType="date" name="releaseDateGroup" [groupIndex]="0"  sortOrder="desc"
                    [calculateGroupValue]="groupByDate"
                    format="MMM yyyy"                     
                    ></dxi-column>
        <dxi-column dataField="releaseDate" dataType="date" sortOrder="desc" alignment="right"
                    [allowEditing]="false"
                    [calculateSortValue]="calculateSortValue"></dxi-column>

        <dxi-column dataField="active" [visible]="false"></dxi-column>

      </dx-data-grid>
    </div>
  </content-column>
</fullscreen-page>
